"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var OutlinedInputTheme = function OutlinedInputTheme(colors, breakpoints) {
  return {
    styleOverrides: {
      root: {
        borderRadius: '8px',
        '&:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderWidth: '1px'
        },
        '&:hover:not(.Mui-error):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
          borderColor: colors.hover
        },
        '&:active:not(.Mui-error):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
          borderColor: colors.click
        },
        '&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
          borderColor: colors.selected
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: colors.redText
        },
        '&.Mui-error': {
          borderColor: colors.redText
        },
        '&.Mui-disabled': {
          borderColor: colors.grey20
        }
      },
      notchedOutline: {
        top: 0,
        borderColor: colors.grey10,
        legend: {
          display: 'none'
        }
      },
      input: {
        padding: '12px 16px',
        height: '16px'
      },
      inputSizeSmall: {
        padding: '8px 16px'
      },
      inputAdornedStart: {
        paddingLeft: 0
      }
    }
  };
};

var _default = OutlinedInputTheme;
exports["default"] = _default;